var map = {
	"./crown.json": [
		"j0r/",
		3
	],
	"./cry.json": [
		"kv3K",
		4
	],
	"./error.json": [
		"Br7M",
		5
	],
	"./message.json": [
		"0hUx",
		6
	],
	"./money.json": [
		"X4Hy",
		7
	],
	"./monocle.json": [
		"vVrx",
		8
	],
	"./regret.json": [
		"YN5v",
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "XJLS";
module.exports = webpackAsyncContext;